export default __webpack_public_path__ + "images/RV.5eb6454.png";